/**
 * Product mockup used in the hero and the pricing card.
 * When empty, a code-drawn six-volume box set is shown instead.
 */
export const PRODUCT_MOCKUP =
  'https://cdn.magicpatterns.com/uploads/kyP1toPGfbBCCjtyep8xHe/Use-the-second-reference-image-as-the-ex.png'

/**
 * Where every buy button sends the coach.
 * TODO: replace with the real Parkour Class-Ready checkout URL once the store exists.
 */
export const CHECKOUT_URL = '#pricing'

export const PRODUCT_MOCKUP_ALT =
  'The Parkour Class-Ready Megapack: six volumes — Foundations & Safe Landings, Vaults & Obstacle Skills, Jumps, Precision & Drops, Walls, Climbing & Bars, Flow, Lines & Creativity, and The Coach\'s Control Room — plus five bonuses'

export const PRODUCT_NAME = 'The Parkour Class-Ready Megapack'
